var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChannelDashboardOpenTicketsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_289",
    x: 0,
    y: 0,
    width: 79,
    height: 79,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff1414",
    floodOpacity: 0.208
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161872",
    "data-name": "Group 161872",
    transform: "translate(-399 -577)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 399, 577)",
    filter: "url(#Ellipse_289)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_289-2",
    "data-name": "Ellipse 289",
    cx: 30.5,
    cy: 30.5,
    r: 30.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "open-access-svgrepo-com",
    d: "M21.106,14.436a8.009,8.009,0,0,0-.564-1.117V6.865a6.92,6.92,0,0,0-1.968-4.854,6.6,6.6,0,0,0-9.483,0A6.908,6.908,0,0,0,7.127,6.865v.941H9.813V6.865a4.13,4.13,0,0,1,1.18-2.91,3.945,3.945,0,0,1,2.841-1.2,4.077,4.077,0,0,1,4.02,4.114v3.759a7.774,7.774,0,0,0-9.631,1.237,8.24,8.24,0,0,0,0,11.451,7.769,7.769,0,0,0,11.187,0,8.272,8.272,0,0,0,1.694-8.88Zm-7.287,8.5a5.348,5.348,0,0,1,0-10.694,5.348,5.348,0,0,1,0,10.694Zm2.242-5.322a2.216,2.216,0,1,1-4.43,0A2.216,2.216,0,1,1,16.06,17.614Z",
    transform: "translate(424.683 600.655)",
    fill: "#d58484"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelDashboardOpenTicketsIcon);
export default __webpack_public_path__ + "static/media/channel-dashboard-open-tickets-icon.237cfbf001eff9996d94950118a1a1b8.svg";
export { ForwardRef as ReactComponent };